module.exports = __webpack_public_path__ + "static/media/lucky_number_background@3x.4686bb1c.png";